import { createAsyncThunk } from '@reduxjs/toolkit'
import qs from 'querystring'
import Api, { paths } from 'shared/services/Api'
import { downloadFile } from 'shared/utils'

const NAMESPACE = 'files'

export const getLawsuitAttachments = createAsyncThunk<
  void,
  {
    lawsuitId: string | number
    fileIds: (string | number)[]
    fileName: string
  },
  { rejectValue: string }
>(
  `${NAMESPACE}/getLawsuitAttachments`,
  async ({ lawsuitId, fileIds, fileName }, { rejectWithValue }) => {
    try {
      const response = await Api.get(
        `${paths.Lawsuits.root}/${lawsuitId}/files`,
        {
          responseType: 'blob',
          params: fileIds.length
            ? {
                fileIds,
              }
            : {
                getAll: true,
              },
          paramsSerializer: params => qs.stringify(params),
        }
      )

      const blob = response.data
      downloadFile(blob, fileName)
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
